import { render, staticRenderFns } from "./current_question.vue?vue&type=template&id=963bcbb0&"
import script from "./current_question.vue?vue&type=script&lang=js&"
export * from "./current_question.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports